import React, { Component, useState, useContext } from 'react';
import Toolbar from '../../components/Header/Toolbar/Toolbar';
import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import PaymentTable from './PaymentTable';

class PaymentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: localStorage.getItem('authToken'),
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
            <Toolbar />
        </div>
        <div className="container-fluid text-center">
          <LowerHeader pageTitle="Payments" />
          <PaymentTable/>
        </div>
      </React.Fragment>
    );
  }
}

export default PaymentContainer;


// WEBPACK FOOTER //
// ./src/containers/PaymentDashboard/PaymentDashboardContainer.js